<template>
  <div id="catalog">
     <div v-if="acti===1" class="input-group md-form form-sm form-2 pl-0 mb-3">
        <template v-if="goods.length > 0 && lang === 'RU'">
         <div class="input-group-prepend">
             <span class="input-group-text text-white blue" title=""><i class="fa fa-search text-grey" aria-hidden="true" ></i></span>
        </div>
        <input ref="inp" class="form-control" v-bind:class="{'red-text':filteredList.length === 0 && goods.length > 0, 'text-primary':filteredList.length > 100 &&  filteredList.length < goods.length}" v-model.trim="search" type="text" placeholder="Поиск" aria-label="Search" title="Введите ключевые слова в поле поиска">
        <span class="input-group-text text-white red hoverable" title="Очистить поле ввода" @click="search=''" id="basic-text1"><i class="fa fa-times text-grey" aria-hidden="true"></i></span>
      </template>
      <template v-if="goods.length > 0 && lang === 'EN'">
         <div class="input-group-prepend">
             <span class="input-group-text text-white blue" title=""><i class="fa fa-search text-grey" aria-hidden="true" ></i></span>
        </div>
        <input ref="inp" class="form-control" v-bind:class="{'red-text':filteredList.length === 0 && goods.length > 0, 'text-primary':filteredList.length > 100 &&  filteredList.length < goods.length}" v-model.trim="search" type="text" placeholder="Search" aria-label="Search" title="Enter keywords">
        <span class="input-group-text text-white red hoverable" title="Clear search field" @click="search=''" id="basic-text1"><i class="fa fa-times text-grey" aria-hidden="true"></i></span>
      </template>
      <template v-if="goods.length > 0 && lang === 'GE'">
         <div class="input-group-prepend">
             <span class="input-group-text text-white blue" title=""><i class="fa fa-search text-grey" aria-hidden="true" ></i></span>
        </div>
        <input ref="inp" class="form-control" v-bind:class="{'red-text':filteredList.length === 0 && goods.length > 0, 'text-primary':filteredList.length > 100 &&  filteredList.length < goods.length}" v-model.trim="search" type="text" placeholder="ძიება" aria-label="Search" title="შეიყვანეთ სიტყვების ძებნა">
        <span class="input-group-text text-white red hoverable" title="საძიებო ველი" @click="search=''" id="basic-text1"><i class="fa fa-times text-grey" aria-hidden="true"></i></span>
      </template>
      </div>
     <template v-if="filteredList.length === 0 && folder1 === '00000000-0000-0000-0000-000000000000' && folder2 === '00000000-0000-0000-0000-000000000000'">
     <div class="card">
      <div v-if="!closetags && folder0 === '00000000-0000-0000-0000-000000000000' && folder1 === '00000000-0000-0000-0000-000000000000' && folder2 === '00000000-0000-0000-0000-000000000000'" class="d-flex justify-content-between align-content-center flex-wrap mb-2 animated pulse">
        <button type="button" class="btn btn-nav blue darken-1 waves-effect" @click="searchFocus(' MOLTEN ')">MOLTEN</button>
        <button type="button" class="btn btn-nav btn-red waves-effect" @click="searchFocus(' KETTLER ')">KETTLER</button>
        <button type="button" class="btn btn-nav btn-red waves-effect" @click="searchFocus(' DUNLOP ')">DUNLOP</button>
        <button type="button" class="btn btn-nav btn-green waves-effect" @click="searchFocus(' CARLTON ')">CARLTON</button>
        <button type="button" class="btn btn-nav btn-red waves-effect" @click="searchFocus(' SLAZENGER ')">SLAZENGER</button>
        <button type="button" class="btn btn-nav blue darken-4 waves-effect" @click="searchFocus(' SVELTUS ')">SVELTUS</button>
        <button type="button" class="btn btn-nav stylish-color-dark waves-effect" @click="searchFocus(' GYMSTICK ')">GYMSTICK</button>
        <button type="button" class="btn btn-nav blue darken-5 waves-effect" @click="searchFocus(' HARROWS ')">HARROWS</button>
        <button type="button" class="btn btn-nav danger-color waves-effect" @click="searchFocus(' BECO ')">BECO</button>
        <button type="button" class="btn btn-nav btn-grey waves-effect" @click="searchFocus(' FASHY ')">FASHY</button>
        <button type="button" class="btn btn-nav btn-elegant waves-effect" @click="searchFocus(' RUCANOR ')">RUCANOR</button>
      </div>
    </div>
      </template>
        <div class="row">
        <div v-for="(good, index) in filteredList" :key="index" class="card col-md-4 mb-2 cascading-admin-card" :id=calculateid(good.Ref_Key) >
        <div class="card-header d-flex flex-wrap justify-content-between align-self-stretch animated fadeIn" v-bind:class="{'blue lighten-5' : good.ConfirmedQty>0 }">
            <b>   {{good.Артикул}} </b>
        </div>
        <div class="card-body">
              <!-- Text -->
                <div class="card-text">
                  <template v-if="lang==='GE'">
                 {{good.Description}}
                 </template>
                 <template v-if="lang==='RU'">
                 {{good.PavadinimasRusuKalba}}
                 </template>
                 <template v-if="lang==='EN'">
                 {{good.PavadinimasAngluKalba}}
                 </template>
               </div>
        </div>
        <div @click.passive="showModal2 = true; selectedItem = good" class="view zoom view-cascade view overlay">
          <template v-if="good.ФайлКартинки.length > 0">
            <img v-if="lang==='RU'" class="card-img-top img-fluid pb-1" :src='good.ФайлКартинки[0]' alt="Фото" title="Подробнее">
            <img v-if="lang==='EN'" class="card-img-top img-fluid pb-1" :src='good.ФайлКартинки[0]' alt="Фото" title="Click for details">
            <img v-if="lang==='GE'" class="card-img-top img-fluid pb-1" :src='good.ФайлКартинки[0]' alt="Фото" title="დაწკაპეთ დეტალები">
          </template>
          <template v-if="good.ФайлКартинки.length === 0">
            <img class="card-img-top img-fluid" src='https://sport.infotronic.by/assets/no-photo.gif' alt="Фото">
          </template>
        </div>
         <div v-if = "true" class="card-footer d-flex flex-wrap justify-content-end" v-bind:class="{'blue lighten-5' : good.ConfirmedQty>0 }">
              <div class="input-group-prepend col" tag="a">
                    <span v-if="lang==='RU'" class=" input-group-text" style="cursor: pointer;" title='Цена с НДС'>{{good.Price}} GEL</span>
                    <span v-if="lang==='EN'" class=" input-group-text" style="cursor: pointer;" title='Price incl. VAT'>{{good.Price}} GEL</span>
                    <span v-if="lang==='GE'" class=" input-group-text" style="cursor: pointer;" title='დღგ-ს ჩათვლით'>{{good.Price}} GEL</span>
                    <template v-if="good.Stock>0">
                        <span v-if="lang==='RU'" style="cursor: pointer;" class="input-group-text success-color-dark text-white" title='На складе'>{{good.Stock}}</span>
                        <span v-if="lang==='EN'" style="cursor: pointer;" class="input-group-text success-color-dark text-white" title='In Stock'>{{good.Stock}}</span>
                        <span v-if="lang==='GE'" style="cursor: pointer;" class="input-group-text success-color-dark text-white" title='საწყობშია'>{{good.Stock}}</span>
                    </template>
              </div>
                 <input  v-if="good.Stock>0 && lang === 'RU'" class="form-control col-3 animated fadeIn" v-bind:class=" {'stock': good.Stock, 'miss': ((good.Stock===0) && (good.DeliveryQty===0)), 'transit':((good.Stock===0) && (good.DeliveryQty>0)), 'skorpiono' : good.Stock===0 && good.DeliveryQty===0 && good.StockS > 0} " type="number" v-bind:value="good.OrderedQty" @input="good.OrderedQty=calculateInput(good,$event)" @keyup="good.OrderedQty=calculateInput(good,$event)" @mousevent="good.OrderedQty=calculateInput(good,$event)" aria-label="Количество для заказа, используйте стрелки вверх-вниз для изменения" title="Количество для заказа, используйте стрелки вверх-вниз для изменения">
                 <input  v-if="good.Stock>0 && lang === 'EN'" class="form-control col-3 animated fadeIn" v-bind:class=" {'stock': good.Stock, 'miss': ((good.Stock===0) && (good.DeliveryQty===0)), 'transit':((good.Stock===0) && (good.DeliveryQty>0)), 'skorpiono' : good.Stock===0 && good.DeliveryQty===0 && good.StockS > 0} " type="number" v-bind:value="good.OrderedQty" @input="good.OrderedQty=calculateInput(good,$event)" @keyup="good.OrderedQty=calculateInput(good,$event)" @mousevent="good.OrderedQty=calculateInput(good,$event)" aria-label="Order quantity, use the up and down arrows to change" title="Order quantity, use the up and down arrows to change">
                 <input  v-if="good.Stock>0 && lang === 'GE'" class="form-control col-3 animated fadeIn" v-bind:class=" {'stock': good.Stock, 'miss': ((good.Stock===0) && (good.DeliveryQty===0)), 'transit':((good.Stock===0) && (good.DeliveryQty>0)), 'skorpiono' : good.Stock===0 && good.DeliveryQty===0 && good.StockS > 0} " type="number" v-bind:value="good.OrderedQty" @input="good.OrderedQty=calculateInput(good,$event)" @keyup="good.OrderedQty=calculateInput(good,$event)" @mousevent="good.OrderedQty=calculateInput(good,$event)" aria-label="დაალაგეთ რაოდენობა, გამოიყენოთ up და down ისრები" title="დაალაგეთ რაოდენობა, გამოიყენოთ up და down ისრები">
                 <div class="input-group-append">
                   <span v-if="good.Stock === 0 && lang === 'RU'">Нет на складе</span>
                   <span v-if="good.Stock === 0 && lang === 'EN'">Out of Stock</span>
                   <span v-if="good.Stock === 0 && lang === 'GE'">არ არის გაყიდვაში</span>
                   <span v-if="lang === 'RU'" @click = "$emit('addGood', good)" type="btn btn-sm" class="input-group-text hoverable" v-bind:class=" {'btn-green': good.Stock, 'btn-warning': ((good.Stock===0) && (good.DeliveryQty===0)), 'btn-info':((good.Stock===0) && (good.DeliveryQty>0)), 'btn-secondary' : good.Stock===0 && good.DeliveryQty===0 && good.StockS > 0} " title="Добавить в корзину"><i class="fas fa-cart-arrow-down"></i></span>
                   <span v-if="lang === 'EN'" @click = "$emit('addGood', good)" type="btn btn-sm" class="input-group-text hoverable" v-bind:class=" {'btn-green': good.Stock, 'btn-warning': ((good.Stock===0) && (good.DeliveryQty===0)), 'btn-info':((good.Stock===0) && (good.DeliveryQty>0)), 'btn-secondary' : good.Stock===0 && good.DeliveryQty===0 && good.StockS > 0} " title="Add to cart"><i class="fas fa-cart-arrow-down"></i></span>
                   <span v-if="lang === 'GE'" @click = "$emit('addGood', good)" type="btn btn-sm" class="input-group-text hoverable" v-bind:class=" {'btn-green': good.Stock, 'btn-warning': ((good.Stock===0) && (good.DeliveryQty===0)), 'btn-info':((good.Stock===0) && (good.DeliveryQty>0)), 'btn-secondary' : good.Stock===0 && good.DeliveryQty===0 && good.StockS > 0} " title="კალათაში დამატება"><i class="fas fa-cart-arrow-down"></i></span>
                 </div>
             </div>
             </div>
       </div>
          <mdb-modal size="lg" v-if="showModal2" @close="showModal2 = false">
            <mdb-modal-header>
              <mdb-modal-title v-if="lang==='GE'"><b>{{selectedItem.Артикул}}</b> {{selectedItem.Description}}</mdb-modal-title>
              <mdb-modal-title v-if="lang==='RU'"><b>{{selectedItem.Артикул}}</b> {{selectedItem.PavadinimasRusuKalba}}</mdb-modal-title>
              <mdb-modal-title v-if="lang==='EN'"><b>{{selectedItem.Артикул}}</b> {{selectedItem.PavadinimasAngluKalba}}</mdb-modal-title>
              </mdb-modal-header>
               <mdb-modal-body>
                <mdb-row @click.native="showModal2 = false">
                 <mdb-col>
                  <mdb-carousel :interval="3000" :half="true" :slide="true">
                   <mdb-carousel-item v-for="(item, index) in selectedItem.ФайлКартинки" :key="index" img :src="item" alt="Image" class="img2"/>
                 </mdb-carousel>
               </mdb-col>
               <mdb-col md="6" class="d-flex align-items-center">
                <template v-if="lang==='GE'">
                   <p class="text-center mt-2">{{selectedItem.Комментарий}}</p>
               </template>
                <template v-if="lang==='RU'">
                   <p class="text-center mt-2">{{selectedItem.AprasymasRusuKalba}}</p>
               </template>
                <template v-if="lang==='EN'">
                   <p class="text-center mt-2">{{selectedItem.AprasymasAngluKalba}}</p>
               </template>
               </mdb-col>
              </mdb-row>
              </mdb-modal-body>
              <mdb-modal-footer>
                  <template v-if="lang==='RU'">
                <mdb-btn color="primary" size="sm" @click.native="showModal2 = false">Закрыть</mdb-btn>
              </template>
              <template v-if="lang==='EN'">
                <mdb-btn color="primary" size="sm" @click.native="showModal2 = false">Close</mdb-btn>
              </template>
              <template v-if="lang==='GE'">
                <mdb-btn color="primary" size="sm" @click.native="showModal2 = false">დახურვა</mdb-btn>
              </template>
             </mdb-modal-footer>
          </mdb-modal>
         <back-to-top bottom="30px" right="30px">
          <button @click="$refs.inp.focus()" type="button" class="btn  red darken-3 hoverable btn-to-top d-none d-lg-block"><i class="fa fa-chevron-up"></i></button>
        </back-to-top>
    </div>
</template>

<script>
import { Row, Column, Btn, Card, CardBody, CardHeader, CardText, Fa, BarChart, PieChart, LineChart, RadarChart, DoughnutChart, ListGroup, ListGroupItem, Badge, Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, mdbCarousel, mdbCarouselItem, mdbBtn, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbCol, mdbRow, mdbCardImage } from 'mdbvue'
export default {
  name: 'catalog',
  components: {
    Row,
    Column,
    Btn,
    Card,
    CardBody,
    CardHeader,
    CardText,
    Fa,
    BarChart,
    PieChart,
    LineChart,
    RadarChart,
    DoughnutChart,
    ListGroup,
    ListGroupItem,
    Badge,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    mdbCarousel,
    mdbCarouselItem,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbCol,
    mdbRow,
    mdbCardImage
  },
  props: ['authorized', 'acti', 'goods', 'orders', 'mng', 'folder0', 'folder1', 'folder2', 'lang'],
  data () {
    return {
      results: [],
      search: '',
      itemsSelected: 0,
      hideSearchTip: false,
      closetags: false,
      inlist: false,
      showModal2: false,
      selectedItem: []
    }
  },
  mounted () {
    // this.UID = this.$localStorage.get('UID', 'false')
    // this.getGoods(this.UID)
    this.hideSearchTip = this.$localStorage.get('hideSearchTip', null, false)
    this.hideOrderTip = this.$localStorage.get('hideOrderTip', null, false)
  },
  created () {
  },
  computed: {
    filteredList () {
      return this.goods.filter(good => {
        var res = false
        if (this.search === '') {
          if (this.folder0 === '00000000-0000-0000-0000-000000000000' && this.folder1 === '00000000-0000-0000-0000-000000000000' && this.folder2 === '00000000-0000-0000-0000-000000000000') {
            return false
          } else if (good.Parent_Key === this.folder0 && this.folder1 === '00000000-0000-0000-0000-000000000000' && this.folder2 === '00000000-0000-0000-0000-000000000000') {
            return true
          } else if (good.Parent_Key === this.folder1 && this.folder2 === '00000000-0000-0000-0000-000000000000') {
            return true
          } else if (good.Parent_Key === this.folder2) {
            return true
          }
        } else if (this.folder1 === '00000000-0000-0000-0000-000000000000' && this.folder2 === '00000000-0000-0000-0000-000000000000') {
          res = true
          var keywords = this.search.split(' ')
          keywords.forEach((element, index) => {
            var str = good.Артикул + ' ' + good.НаименованиеПолное + ' ' + good.Description + good.AprasymasAngluKalba + good.AprasymasRusuKalba + good.PavadinimasAngluKalba + good.PavadinimasRusuKalba + good.Комментарий
            var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
            if (res === true && res1 === true) res = true
            if (res === false || res1 === false) res = false
          })
          return res
        } else {
          if (good.Parent_Key === this.folder1 || good.Parent_Key === this.folder2) {
            res = true
            var keywords1 = this.search.split(' ')
            keywords1.forEach((element, index) => {
              var str = good.Артикул + ' ' + good.НаименованиеПолное + ' ' + good.Description + good.AprasymasAngluKalba + good.AprasymasRusuKalba + good.PavadinimasAngluKalba + good.PavadinimasRusuKalba + good.Комментарий
              var res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
              if (res === true && res1 === true) res = true
              if (res === false || res1 === false) res = false
            })
            return res
          }
        }
      })
    },
    element (good) {
      return good.Ref_Key
    },
    showpicture () {
      // console.log(this)
      return true
    }
  },
  methods:
    {
      calculateInput (good, event) {
        // console.log(event.target.value)
        if (event.target.value <= 0) {
          event.target.value = ''
          return ''
        } else {
          return event.target.value
        }
      },
      ChangeItem (good) {
        this.$emit('orderedItems')
      },
      calculateid (refkey) {
        return 'i' + refkey
      },
      transit (good) {
        return 'Транзит к ' + this.$moment(good.DeliveryDate).format('DD-MM-YYYY')
      },
      searchFocus (str) {
        this.showOnce = false
        this.$refs.inp.focus()
        // console.log(str)
        this.search += str
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .card-img-top {
    width: 100%;
    height: 10vw;
    object-fit: scale-down;
  }
  .img2 {
    width: 100%;
    height: 30vw;
    object-fit: scale-down;
  }
  .btn-to-top {
    border-radius: 50%;
    padding: 1rem;
    padding-top: 0.9rem;
    padding-right: 1.1rem;
    padding-bottom: 0.9rem;
    padding-left: 1.1rem;
  }
.btn.btn-nav {
    padding: 0.1rem 1.0rem;
    font-size: 0.64rem;
  }
.badge-pill {
    border-radius: 10rem;
    padding-right: 0.6em;
    margin-top: 0.6em;
  }
.form-control:focus {
    border:0px
    }
.form-control {
    height:auto
    }
.order-btn {
    margin-top: 0.375rem;
    margin-left: 0rem;
    }
.search {
    border: 1px solid #1e282d;
    }
.stock {
    border: 1px solid #007e33;
    }
.miss {
    border: 1px solid #ffbb33;
    }
 .skorpiono {
    border: 1px solid #9933cc;
    }
.transit {
    border: 1px solid #ff8800;
    }
.w-120 {
    width: 120px!important;
}
.w-50 {
    width: 60px!important;
}
.inp {
    font-size: 1.5rem;
}
.md-form {
    position: relative;
    margin-top: 0rem;
    margin-bottom: 0rem;
}
.cascading-admin-card {
  padding-left: 5px;
  padding-right: 5px;
}
.m-0 {
    margin: 0.4rem!important;
}
.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
}
.cascading-admin-card .admin-up .fa {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 20px 0 rgba(0, 0, 0, 0.19);
}
.cascading-admin-card .admin-up .fa {
  padding: 1.7rem;
  font-size: 2rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
}
.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}
.admin-up .data p {
  color: #999999;
  font-size: 12px;
}
.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}
  .card-text {
  font-size: 16px;
  opacity: 1.0;
  margin-bottom: 0;
  margin-left: 1rem;
  font-weight: 300;
}
.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalog.vue